import dayjs from "dayjs";

/* ============================================================================
 * Helpers genéricos (apenas numéricos/datas — sem nada de frequência)
 * ==========================================================================*/
export const fmtNum = (v, dec = 2) =>
  Number.isFinite(Number(v)) ? Number(v).toFixed(dec) : "-";

export const cpkBadgeVariant = (cpk) => {
  const n = Number(cpk);
  if (!Number.isFinite(n)) return "secondary";
  if (n >= 1.33) return "success";
  if (n >= 1.0) return "warning";
  return "danger";
};

/* ============================================================================
 * Utils p/ lidar com <input type="datetime-local">
 * - O input espera "YYYY-MM-DDTHH:mm"
 * - Mantemos a string original (com segundos) para a URL
 * ==========================================================================*/
export function toLocalInputValue(isoStr) {
  if (!isoStr) return "";
  const d = dayjs(isoStr);
  return d.isValid() ? d.format("YYYY-MM-DDTHH:mm") : "";
}

export function fromLocalInputValue(localStr) {
  if (!localStr) return "";
  return dayjs(localStr).isValid()
    ? dayjs(localStr).format("YYYY-MM-DDTHH:mm:ss")
    : "";
}

export const hasStatAlert = (ctr) => {
  const bounds = ctr?.estatisticas?.bounds || [];
  if (!Array.isArray(bounds) || bounds.length === 0) return false;

  // Extrai valores numéricos válidos
  const valores = bounds
    .map((b) => Number(b?.valor))
    .filter((v) => Number.isFinite(v));

  if (valores.length === 0) return false;

  const min = Math.min(...valores);
  const max = Math.max(...valores);

  // Considera apenas os bounds com valor igual ao mínimo ou máximo
  return bounds.some((b) => {
    const v = Number(b?.valor);
    if (!Number.isFinite(v)) return false;
    if (v !== min && v !== max) return false;

    const atendidos = Number(b?.atendidos);
    const total = Number(b?.total);
    if (!Number.isFinite(atendidos) || !Number.isFinite(total)) return false;

    return atendidos < total;
  });
}

// format mileseconds to hh:mm
export const formattedTime = (ms) => {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  return `${hours}h ${minutes}m`;
};



